/**
 * 商品列表接口
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'status',
      desc: '获取付款管理页签',
      method: 'GET',
      path: '/tm/purchase/payment/getStatusCount'
    },
    {
      name: 'list',
      desc: '付款单列表',
      method: 'GET',
      path: '/tm/purchase/payment/selectList'
    },
    {
      name: 'selectPayDetail',
      desc: '付款单详情',
      method: 'GET',
      path: '/tm/purchase/payment/selectPayDetail'
    },
    {
      name: 'save',
      desc: '保存付款单',
      method: 'POST',
      path: '/tm/purchase/payment/save'
    },
    {
      name: 'exportPur',
      desc: '预付款单列表导出',
      method: 'GET',
      path: '/tm/purchase/payment/exportPur'
    },
    {
      name: 'exportTail',
      desc: '尾款单列表导出',
      method: 'GET',
      path: '/tm/purchase/payment/exportTail'
    },
    {
      name: 'orgList',
      desc: '付款管理-企业列表',
      method: 'GET',
      path: '/sob/payment/support/org/list'
    },
    {
      name: 'payList',
      desc: '付款管理-付款记录',
      method: 'POST',
      path: '/sob/payment/list'
    },
    {
      name: 'createPay',
      desc: '付款管理-创建付款单',
      method: 'POST',
      path: '/sob/payment/createPay'
    },
    {
      name: 'reducePay',
      desc: '付款管理-多付款修改',
      method: 'POST',
      path: '/sob/payment/reduce'
    },
    {
      name: 'purchaseList',
      desc: '付款管理-采购单据',
      method: 'POST',
      path: '/sob/payment/purchase/list'
    },
    {
      name: 'payOperator',
      desc: '付款管理-操作人',
      method: 'GET',
      path: '/sob/payment/operator'
    },
    {
      name: 'payHistory',
      desc: '付款管理-操作明细',
      method: 'POST',
      path: '/sob/payment/pay/list'
    },
    {
      name: 'payChange',
      desc: '付款管理-多付变更记录',
      method: 'GET',
      path: '/sob/payment/change/list'
    },
    {
      name: 'payType',
      desc: '付款管理-变更类型',
      method: 'GET',
      path: '/sob/payment/payType'
    },
    {
      name: 'paymentStatus',
      desc: '付款管理-付款状态',
      method: 'GET',
      path: '/sob/payment/paymentStatus'
    },
    {
      name: 'payExport',
      desc: '付款管理-采购单据导出',
      method: 'POST',
      path: '/sob/payment/purchase/list/export'
    },
    {
      name: 'payChangeeExport',
      desc: '付款管理-付款记录导出',
      method: 'POST',
      path: '/sob/payment/pay/list/export'
    },
    {
      name: 'supportMember',
      desc: '付款管理-运营支撑员',
      method: 'GET',
      path: '/sob/payment/supportMember'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/payment/index.js